export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сома"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нәтиже"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Транзакция"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Статусты жаңарту"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пайдалы сілтемелер"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Блокчейн:"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жүріп жатыр"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сәтті"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сәтсіз"])}
}